import { alpha, Box, Typography } from '@mui/material';
import { FC } from 'react';

import { medium } from '@styles/fontWeights';

type ApplicationStatusBadgeProps = {
  label: string;
  color: string;
};

const ApplicationStatusBadge: FC<ApplicationStatusBadgeProps> = ({
  label,
  color,
}) => (
  <Box px={2} py={1} bgcolor={alpha(color, 0.2)} borderRadius='5px'>
    <Typography color={color} textTransform="capitalize" fontWeight={medium} style={{ fontSize: '13px', lineHeight: '13px' }}>
      {label.toLowerCase()}
    </Typography>
  </Box>
);

export default ApplicationStatusBadge;
